import script from "./ManagementOrderMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementOrderMonitor.vue?vue&type=script&setup=true&lang=js"

import "./ManagementOrderMonitor.vue?vue&type=style&index=0&id=66d1b0d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d1b0d6"]])

export default __exports__